import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const CreateRutaParte = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/rutas_partes/${params.id}`, params.data, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        crearRutaParteMutation: mutation.mutate,
    };
}